export default __webpack_public_path__ + "static/media/bottom-banner.f5c137c1.jpg";